<div class="container">

  <!-- ── Bio header ─────────────────────────────── -->
  <div class="bio-header">
    <div class="bio-top">
      <div>
        <h2 class="bio-name">Oleh Rumyk</h2>
        <p class="bio-role">DevOps Engineer &nbsp;·&nbsp; 23+ years in IT &nbsp;·&nbsp; 6+ in DevOps</p>
      </div>
      <a mat-stroked-button [href]="linkedIn" target="_blank" rel="noopener" class="linkedin-btn">
        <mat-icon>open_in_new</mat-icon>LinkedIn
      </a>
    </div>
    <p class="bio-text">{{ headerText }}</p>
  </div>

  <!-- ── Sections ───────────────────────────────── -->
  <div class="sections-grid">

    <mat-card class="section-card comp-card" appearance="outlined">
      <mat-card-header>
        <span class="section-badge comp-badge">
          <mat-icon>verified</mat-icon>
        </span>
        <mat-card-title class="section-title comp-title">Key Competencies</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <div class="items-list">
        @for (item of competencies; track item.data) {
          <div class="list-row">
            <mat-icon class="bullet comp-bullet">check_circle</mat-icon>
            <span>{{ item.data }}</span>
          </div>
        }
      </div>
    </mat-card>

    <mat-card class="section-card ach-card" appearance="outlined">
      <mat-card-header>
        <span class="section-badge ach-badge">
          <mat-icon>emoji_events</mat-icon>
        </span>
        <mat-card-title class="section-title ach-title">Key Achievements</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <div class="items-list">
        @for (item of achievements; track item.data) {
          <div class="list-row">
            <mat-icon class="bullet ach-bullet">star</mat-icon>
            <span>{{ item.data }}</span>
          </div>
        }
      </div>
    </mat-card>

  </div>
</div>
